import { render, staticRenderFns } from "./CustomerTypeModal.vue?vue&type=template&id=19513da4&scoped=true"
import script from "./CustomerTypeModal.vue?vue&type=script&lang=js"
export * from "./CustomerTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerTypeModal.vue?vue&type=style&index=0&id=19513da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19513da4",
  null
  
)

export default component.exports